<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'App',
}
</script>
<style>
#app {
  font-family: 'Source Sans Pro', sans-serif;
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

.bg-dark {
  background-color: black !important;
}

.btn-dark {
  background-color: black !important;
}


</style>
